// Conversions entre l'espace image d'un plan (coordonnées stockées des pins)
// et l'espace visuel après rotation horaire. Fonctions pures, sans Konva :
// partagées par le viewer (saisie) et l'export (dessin) pour rester l'inverse
// exact l'une de l'autre.

export type PlanRotation = 0 | 90 | 180 | 270;

/** Convertir des coordonnées visuelles (espace écran) en coordonnées originales (espace image) */
export function visualToOriginal(vx: number, vy: number, rotation: PlanRotation, imgW: number, imgH: number) {
  switch (rotation) {
    case 90:  return { x: vy, y: imgH - vx };
    case 180: return { x: imgW - vx, y: imgH - vy };
    case 270: return { x: imgW - vy, y: vx };
    default:  return { x: vx, y: vy };
  }
}

/** Convertir des coordonnées originales (espace image) en coordonnées visuelles (plan tourné) */
export function originalToVisual(x: number, y: number, rotation: PlanRotation, imgW: number, imgH: number) {
  switch (rotation) {
    case 90:  return { x: imgH - y, y: x };
    case 180: return { x: imgW - x, y: imgH - y };
    case 270: return { x: y, y: imgW - x };
    default:  return { x, y };
  }
}
